/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { WalletClientStatus } from "./WalletClientStatus";
import * as t from "io-ts";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

// required attributes
const WalletClientR = t.interface({
  status: WalletClientStatus
});

// optional attributes
const WalletClientO = t.partial({
  lastUsage: UTCISODateFromString
});

export const WalletClient = t.intersection(
  [WalletClientR, WalletClientO],
  "WalletClient"
);

export type WalletClient = t.TypeOf<typeof WalletClient>;
